import BiddersService from "../BiddersService";
import _ from 'lodash';
import i18n from "../../../shared/i18n";
import {
  BIDDERS_TABLE_NAME,
  SOURCE_BIDDERS_TABLE,
  SOURCE_NEGOTIATIONS_MODAL
} from "../../constants";
import BidderSearch from "../BidderSearch.model";
import {store} from "@/plugins/vuex";
import CustomerIdentificationFormModel from "../../customer/models/CustomerIdentificationForm.model";
import {hasPermission} from "@/core/directives/permission";

let getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
    search: '',
    searchModel: new BidderSearch(),
    extraFilters: {},
    expand: 'auction.currency,lots,language,preferred_clerk,total_notes,total_purchases,customer' + ( hasPermission('view_customeraddress') ? ',customer.billing_address,customer.display_billing_address' : ''),
    toggleColumns: {
      fields: [...getDefaultFields(), ...differentFields],
      dynamicFields: [],
      requiredFields: ['customer_uuid', 'status'],
      defaultFields: ['customer_uuid', 'status', 'customer_email', 'preferred_clerk', 'language', 'sale_no',
        'total_purchases', 'trust_level', 'date', 'total_spent', 'company_name', 'credit_limit', 'actions'],
    }
  }
};

const customerIdentificationModel = new CustomerIdentificationFormModel()

const getDefaultFields = () => {
  let fields = [
    {
      key: "customer_uuid",
      label: i18n.t('Customer'),
      sortable: true,
      tdClass: 'customer-col',
      isVisible: true,
      expand: 'customer.term'
    },
    {
      key: "customer_email",
      label: i18n.t('Email'),
      sortable: true,
      tdClass: 'customer-email-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "sale_no",
      label: i18n.t('Sale'),
      sortable: true,
      tdClass: 'sale-no-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "paddle_number",
      label: i18n.t('Paddle Number'),
      sortable: true,
      tdClass: 'paddle-number-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "company_name",
      label: i18n.t('Company Name'),
      tdClass: 'company-name-col',
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: "is_company",
      label: i18n.t('Is Company'),
      tdClass: 'is_company-col',
      sortable: false,
      isVisible: false,
      expand: ''
    },
    {
      key: "preferred_clerk",
      label: i18n.t('Preferred Clerk'),
      tdClass: 'preferred-clerk-col',
      isVisible: true,
      expand: ''
    },
    {key: "language", label: i18n.t('Language'), tdClass: 'language-col', isVisible: true, expand: ''},
    {
      key: "total_spent",
      label: i18n.t('Amount Spent'),
      sortable: true,
      tdClass: 'total-spent-col',
      isVisible: true,
      expand: ''
    },
    {key: "date", label: i18n.t('Registration Date'), sortable: true, tdClass: 'date-col', isVisible: true, expand: ''},
    {key: "status", label: i18n.t('Status'), tdClass: 'status-col', isVisible: true, expand: ''},
    {
      key: 'actions',
      label: i18n.t('Actions'),
      sortable: false,
      tdClass: 'actions-col',
      isVisible: true,
      expand: '',
      exclude_from_export: true
    },
    {
      key: 'client_tier',
      label: i18n.t('Client Tier'),
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'customer'
    },
    {
      key: 'personal_identification_number',
      label: customerIdentificationModel.attributeLabels.personal_identification_number,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'customer.identification'
    },
    {
      key: 'document_type',
      label: customerIdentificationModel.attributeLabels.document_type,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'customer.identification'
    },
    {
      key: 'document_number',
      label: customerIdentificationModel.attributeLabels.document_number,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'customer.identification'
    },
    {
      key: 'document_issue_date',
      label: customerIdentificationModel.attributeLabels.document_issue_date,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'customer.identification'
    },
    {
      key: 'document_expiry_date',
      label: customerIdentificationModel.attributeLabels.document_expiry_date,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'customer.identification'
    },
    {
      key: 'date_of_birth',
      label: customerIdentificationModel.attributeLabels.date_of_birth,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'customer.identification'
    },
    {
      key: 'citizenship_code',
      label: customerIdentificationModel.attributeLabels.citizenship_code,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'customer.identification'
    },
    {
      key: 'residency_code',
      label: customerIdentificationModel.attributeLabels.residency_code,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'customer.identification'
    },
    {
      key: 'country_of_birth_code',
      label: customerIdentificationModel.attributeLabels.country_of_birth_code,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'customer.identification'
    },
    {
      key: 'place_of_issue',
      label: customerIdentificationModel.attributeLabels.place_of_issue,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'customer.identification'
    },
    {
      key: 'company_reg_number',
      label: customerIdentificationModel.attributeLabels.company_reg_number,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'customer.identification'
    },
    {
      key: 'company_vat_tax_number',
      label: customerIdentificationModel.attributeLabels.company_vat_tax_number,
      sortable: true,
      isVisible: false,
      tdClass: '',
      expand: 'customer.identification'
    },
    {
      key: 'trust_level',
      label: customerIdentificationModel.attributeLabels.trust_level,
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: ''
    },
    {
      key: 'total_purchases',
      label: customerIdentificationModel.attributeLabels.total_purchases,
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: ''
    },
    {
      key: 'identity_verification',
      label: i18n.t('Identity Verification'),
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: 'customer.term'
    },
    {
      key: 'kyc_status_verification',
      label: i18n.t('Account/KYC Verification'),
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: 'customer.term'
    },
    {
      key: "customer_primary_phone",
      label: i18n.t('Phone'),
      sortable: true,
      tdClass: 'customer-email-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "watchlist",
      label: i18n.t('Watchlist'),
      sortable: false,
      tdClass: 'watchlist-col',
      isVisible: true,
      expand: 'watchlist'
    },
    {
      key: 'shipping_address_1',
      label: i18n.t('Shipping Address 1'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'customer.shipping_address'
    },
    {
      key: 'shipping_address_2',
      label: i18n.t('Shipping Address 2'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'customer.shipping_address'
    },
    {
      key: 'shipping_state',
      label: i18n.t('Shipping State'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'customer.shipping_address'
    },
    {
      key: 'shipping_county',
      label: i18n.t('Shipping County'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'customer.shipping_address'
    },
    {
      key: 'shipping_city',
      label: i18n.t('Shipping City'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'customer.shipping_address'
    },
    {
      key: 'shipping_zip_code',
      label: i18n.t('Shipping Zip/Post Code'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'customer.shipping_address'
    },
    {
      key: 'shipping_country',
      label: i18n.t('Shipping Country'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'customer.shipping_address.country'
    },
    {
      key: 'billing_address_1',
      label: i18n.t('Billing Address 1'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'customer.billing_address'
    },
    {
      key: 'billing_address_2',
      label: i18n.t('Billing Address 2'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'customer.billing_address'
    },
    {
      key: 'billing_state',
      label: i18n.t('Billing State'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'customer.billing_address'
    },
    {
      key: 'billing_county',
      label: i18n.t('Billing County'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'customer.billing_address.country'
    },
    {
      key: 'billing_city',
      label: i18n.t('Billing City'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'customer.billing_address'
    },
    {
      key: 'billing_zip_code',
      label: i18n.t('Billing Zip/Post Code'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'customer.billing_address'
    },
    {
      key: 'billing_country',
      label: i18n.t('Billing Country'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'customer.billing_address.country'
    },
    {
      key: 'total_commission_bids',
      label: i18n.t('Comm. Bids Count'),
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: 'total_commission_bids'
    },
    {
      key: 'total_telephone_bids',
      label: i18n.t('Tel. Bids Count'),
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: 'total_telephone_bids'
    },
    {
      key: 'credit_limit',
      label: i18n.t('Bidding Limit'),
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: ''
    },
  ]
  const excludeFields = [];
  if (!hasPermission('view_customeridentification')) {
    excludeFields.push('identity_verification');
    excludeFields.push('kyc_status_verification');
    excludeFields.push('personal_identification_number');
    excludeFields.push('document_type');
    excludeFields.push('document_number');
    excludeFields.push('document_issue_date');
    excludeFields.push('document_expiry_date');
    excludeFields.push('date_of_birth');
    excludeFields.push('citizenship_code');
    excludeFields.push('residency_code');
    excludeFields.push('country_of_birth_code');
    excludeFields.push('place_of_issue');
    excludeFields.push('company_reg_number');
    excludeFields.push('company_vat_tax_number');
  }
  if (excludeFields.length) {
    fields = fields.filter(f => !excludeFields.includes(f.key));
  }
  return fields
}

export default {
  namespaced: true,
  state: {
    statuses: [
      {value: 'approved', key: i18n.t('Approved'),},
      {value: 'pending', key: i18n.t('Pending'),},
      {value: 'blocked', key: i18n.t('Blocked'),},
    ],
    modal: {
      show: false,
      object: null,
      source: null
    },
    infoModal: {
      show: false,
      object: null
    },
    tableSource: null,
    tableData: {
      sale: getDefaultTableData(),
      bidders: getDefaultTableData(),
      liveBids: getDefaultTableData(),
    },
  },
  actions: {
    initTableData({state}) {
      state.tableData = {
        sale: getDefaultTableData(),
        bidders: getDefaultTableData(),
        liveBids: getDefaultTableData(),
      }
      return true
    },
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    async updateBidderModalCustomer({state}, payload) {
      let obj = _.cloneDeep(state.modal.object);
      obj.customer_uuid = payload.uuid;
      obj.customer = payload;
      state.modal.object = obj;
    },
    async showModal({commit}, {object = null, source} = {}) {
      commit('showModal', {object: _.cloneDeep(object), source});
    },
    async hideModal({commit}) {
      commit('hideModal');
    },
    async showInfoModal({commit}, {object = null} = {}) {
      commit('showInfoModal', {object: _.cloneDeep(object)});
    },
    async hideInfoModal({commit}) {
      commit('hideInfoModal');
    },
    async updateTableSource({state}, {extraFilters, source}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
    },
    async getTableParams({state}, payload = null) {
      let data;
      let tableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: tableData,
        tableName: BIDDERS_TABLE_NAME
      });

      if (payload) {
        data = {...payload.pagination, search: payload.search, ordering: payload.ordering,};
      } else {
        data = {...tableData.pagination, search: tableData.search, ordering: ordering}
      }

      if (tableData.searchModel) {
        const searchModelData = tableData.searchModel.toJSON();
        data = {...data, ...searchModelData}
      }

      if (tableData.extraFilters) {
        data = {...data, ...tableData.extraFilters};
      }
      // 'lots' is needed for optimal selects on backend.

      const defaultExpand = tableData.expand
      const expand = tableData.toggleColumns.fields
        .filter(c => tableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
        .map(c => c.expand)
        .join(',')

      data.expand = `${expand},${defaultExpand}`;
      return data;
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await BiddersService.getBidders(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }
      return response;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new BidderSearch({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      const expand = state.tableData[state.tableSource].expand;
      const tmpToggleColumns = _.cloneDeep(state.tableData[state.tableSource].toggleColumns);
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].extraFilters = extraFilters;
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      state.tableData[state.tableSource].expand = expand;
      dispatch('getTableData');
    },
    async createBidder({dispatch, state}, payload) {
      let response = await BiddersService.createBidder(payload, 'customer,auction.currency,language,preferred_clerk');
      if (response.success) {
        if (state.modal.source === SOURCE_BIDDERS_TABLE) {
          dispatch('getTableData');
        } else if (state.modal.source === SOURCE_NEGOTIATIONS_MODAL) {
          dispatch('lots/updateNegotiationActiveBidder', response.body, {root: true});
        }
      }
      return response;
    },
    async updateBidder({dispatch, state}, bidder) {
      let response = await BiddersService.updateBidder(bidder.uuid, bidder, 'customer.billing_address,auction.currency,language,preferred_clerk');
      if (response.success && state.modal.source === SOURCE_BIDDERS_TABLE) {
        dispatch('getTableData');
      }
      return response;
    },
    async removeBidder({dispatch}, bidder) {
      let response = await BiddersService.removeBidder(bidder.uuid);
      if (response.success) {
        dispatch('getTableData');
      }
      return response;
    },
    async batchPrintPaddleNumbers({}, uuids) {
      return await BiddersService.batchPrintPaddleNumbers(uuids);
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
  },
  mutations: {
    showModal: (state, {object, source}) => {
      state.modal.show = true;
      state.modal.object = object;
      state.modal.source = source;
    },
    showInfoModal: (state, {object}) => {
      state.infoModal.show = true;
      state.infoModal.object = object;
    },
    hideModal: (state) => state.modal.show = false,
    hideInfoModal: (state) => {
      state.infoModal.show = false;
      state.infoModal.object = null;
    },
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {...state.tableData[state.tableSource], ...payload},
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateBidder: (state, bidder) => {
      const index = state.tableData[state.tableSource].rows.findIndex(i => i.uuid === bidder.uuid);
      state.tableData[state.tableSource].rows[index] = {...state.tableData[state.tableSource].rows[index], ...bidder};
      state.tableData[state.tableSource].rows = [...state.tableData[state.tableSource].rows];
    },
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    updateToggleColumns: (state, selectedColumns) => {
      if (!state.tableSource) {
        return;
      }
      state.tableData[state.tableSource].toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData[state.tableSource].toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData[state.tableSource].toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData[state.tableSource].toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
  }
}
